// Management & staff (About page). `type`: "management" (Board / management tab) or "staff" (Our Team tab).
// SAMPLE DATA — replace with the client's real people.
const management = [
  {
    id: 1,
    name: "Md. Abdul Kader",
    type: "management",
    role: "Chairman",
    desc: "Guides the vision of Unity Health Centre and its commitment to ethical, affordable mental healthcare.",
    img: "/assets/images/team/1.jpg",
  },
  {
    id: 2,
    name: "Md. Kamrul Hasan",
    type: "management",
    role: "Managing Director",
    desc: "Oversees hospital operations, quality of care and patient safety across all units.",
    img: "/assets/images/team/2.jpg",
  },
  {
    id: 3,
    name: "Rokeya Begum",
    type: "management",
    role: "Director, Patient Welfare",
    desc: "Leads family support, the female unit administration and patient welfare programmes.",
    img: "/assets/images/team/3.jpg",
  },
  {
    id: 4,
    name: "Md. Saiful Islam",
    type: "management",
    role: "Director, Operations",
    desc: "Manages admissions, facilities and the daily running of inpatient services.",
    img: "/assets/images/team/4.jpg",
  },
  {
    id: 5,
    name: "Abu Taher",
    type: "management",
    role: "Hospital Administrator",
    desc: "Coordinates staff, schedules and communication between departments and families.",
    img: "/assets/images/team/5.jpg",
  },
  {
    id: 6,
    name: "Jahangir Alam",
    type: "management",
    role: "Head of Nursing & Care",
    desc: "Supervises the 24/7 nursing and attendant team and the patients' daily care routine.",
    img: "/assets/images/team/6.jpg",
  },
  {
    id: 7,
    type: "staff",
    name: "Farhana Akter",
    role: "Senior Staff Nurse",
    desc: "Leads nursing care in the female unit.",
    img: "/assets/images/team/3.jpg",
  },
  {
    id: 8,
    type: "staff",
    name: "Rafiq Mia",
    role: "Senior Attendant",
    desc: "Supports patients' daily routine in the male unit.",
    img: "/assets/images/team/5.jpg",
  },
  {
    id: 9,
    type: "staff",
    name: "Sharmin Sultana",
    role: "Front Desk Officer",
    desc: "Helps families with appointments and admissions.",
    img: "/assets/images/team/6.jpg",
  },
  {
    id: 10,
    type: "staff",
    name: "Kamal Hossain",
    role: "Yoga & Fitness Instructor",
    desc: "Runs the daily exercise, yoga and meditation sessions.",
    img: "/assets/images/team/4.jpg",
  },
];

export default management;
